import React from 'react'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import Modal from '../../../components/common/Modal'
import { api } from '../../../configs/api'
import { useBusiness } from '../../../context/BusinessContext'

const BusinessDeleteStep = ({ open, handleClose }: { open: boolean; handleClose: () => void }) => {
    const { business, setBusiness, currentTab, currentStep } = useBusiness()
    const form = useForm({ mode: 'onChange' })
    const formRef = React.useRef<HTMLFormElement>(null)
    const steps = business.pipelines?.find((pipeline: any) => pipeline?.value == currentTab)?.steps
    const businessCount = steps?.find((step: any) => step?.id == currentStep?.id)?.business?.length || null

    //! Remove a fase do contexto
    const updateStepContext = () => {
        const pipelineIndex = business.pipelines.findIndex((pipeline: any) => pipeline.value === currentTab)
        if (pipelineIndex === -1) return
        const stepIndex = business.pipelines[pipelineIndex].steps.findIndex((step: any) => step.id == currentStep?.id)
        if (stepIndex === -1) return
        business.pipelines[pipelineIndex].steps.splice(stepIndex, 1)
        setBusiness({ ...business })
    }

    const handleDelete = async () => {
        const id = currentStep?.id
        if (!currentStep || !id) {
            toast.error('Fase não encontrada!')
            return
        }

        try {
            const response = await fetch(`${api}business/deleteStep`, {
                method: 'POST',
                body: JSON.stringify({ stepID: id })
            })
            const result = await response.json()

            if (!result.success) {
                toast.error(result.message || 'Erro ao excluir a fase!')
                return
            }

            updateStepContext()
            toast.success('Fase excluída com sucesso!')
        } catch (error) {
            console.log(error)
        } finally {
            handleClose()
        }
    }

    if (!open) return null

    return (
        <Modal
            open={open}
            handleClose={handleClose}
            title='Excluir Fase'
            maxWidth='max-w-xl'
            handleDelete={() => formRef.current?.requestSubmit()}
            canDelete={!businessCount}
        >
            <form ref={formRef} onSubmit={form.handleSubmit(handleDelete)}>
                <div className='text-gray-800 dark:text-white/90 text-sm'>
                    {!businessCount && (
                        <p>
                            Tem certeza que deseja exluir a fase{' '}
                            <strong className='text-error-400'>{currentStep?.title}</strong> ?
                        </p>
                    )}
                    {businessCount && businessCount > 0 && (
                        <p className='text-gray-800 dark:text-white/90 text-sm mt-2'>
                            Você não pode excluir esta fase, pois a mesma contém{' '}
                            <strong className='text-error-400'>{businessCount} negócios</strong>. Remova todos os
                            negócios da fase antes de excluir.
                        </p>
                    )}
                </div>
            </form>
        </Modal>
    )
}

export default BusinessDeleteStep
